import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import { useLineItemsListSections } from "@/pages/(app)/returns/refund/hooks/use-line-items-list-sections";
import useLineItemsQuantitiesSummary from "@/pages/(app)/returns/refund/hooks/use-line-items-quantities-summary";
import {
  useNotTreatedByMerchant,
  useSetNotTreatedByMerchant,
} from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context";
import { useRefundLineItem } from "@/pages/(app)/returns/refund/hooks/use-refund-line-items-context";
import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import { Badge } from "@babackapp/ui/components/badge";
import NumberFlow from "@number-flow/react";
import { ArticleItem } from "../article-item/article-item";
import useTranslation from "@babackapp/translations/use-translation";

export default function ArticlesToHandleByMerchant() {
  const { itemsToShowToHandle } = useLineItemsListSections();
  const isAdmin = useViewerHasAtLeastAdminRights();
  const summary = useLineItemsQuantitiesSummary({
    state: "not-treated-by-merchant",
  });
  const t = useTranslation();
  if (!itemsToShowToHandle.length || !isAdmin) return null;

  return (
    <AccordionItem value="toHandleByMerchant">
      <AccordionTrigger>
        <span>
          {t("returnDetail.confirmModal.toTreat")}
          <Badge variant="secondary" className="ml-2">
            <NumberFlow value={summary.selected} suffix={` / ${summary.max}`} />
          </Badge>
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="border-border border rounded-md flex-col gap-4 divide-y overflow-hidden">
          {itemsToShowToHandle.map((lineItem, index) => (
            <ToHandleByMerchantArticle lineItem={lineItem} key={index} />
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}

function ToHandleByMerchantArticle({
  lineItem,
}: {
  lineItem: ReturnRequestLineItemDto;
}) {
  const { item, updateResolution, updateVariant } = useRefundLineItem(lineItem);
  const quantityValue = useNotTreatedByMerchant(lineItem.line_item_id);
  const updateQuantity = useSetNotTreatedByMerchant(lineItem.line_item_id);

  return (
    <ArticleItem
      lineItem={item}
      quantity={quantityValue.selectedQuantity}
      maxQuantity={quantityValue.maxQuantity}
      onChangeQuantity={updateQuantity}
      onChangeVariant={updateVariant}
      onChangeResolution={updateResolution}
      hideStatus
    />
  );
}
